import { render, staticRenderFns } from "./UserCardRightsOffice.vue?vue&type=template&id=e7308b96&scoped=true&"
import script from "./UserCardRightsOffice.vue?vue&type=script&lang=ts&"
export * from "./UserCardRightsOffice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7308b96",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
